import React from 'react';
import {
  Input,
  Button,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import SelectAPI from './SelectAPI';
import Strings from '../strings/Strings';
import BaseService from '../services/BaseService';
import Loader from './Loader';
// import CustomInput from './CustomInput';

class AccessPointCreditCreate extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      credit: '',
      accesspoint: null,
      accesspointInvalid: false, 
      loading: false,
      error_message: '',
      color_message: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.valid_field = this.valid_field.bind(this);
    this.register = this.register.bind(this);

    console.log(this.props.user.access_token);

  }
  componentWillUpdate(nextProps, nextState) {
    // dispatching an action based on state change
    if (nextProps.editing !== null && nextProps.editing !== this.props.editing) {
      this.setState({
        credit: nextProps.editing.credit,
        accesspoint: (Boolean(nextProps.editing.vehicle_type) === true ? nextProps.editing.accesspoint : null),
      });
    }
  }
  handleInputChange (event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
  }
  toggle(refresh){
    this.setState({
      credit: '',
      accesspoint: null,
      accesspointInvalid: false,
      error_message: '',
      color_message: '',
    });
    this.props.toggle(refresh);
  }
  valid_field(){
    var invalid = false;

    // Valid input
    if(invalid===true){
      return false;
    }

    // Success
    return true;
  }
  async register() {
    if(!this.valid_field()){
      return; 
    }
    this.setState({loading : true});
    let url = BaseService.ENDPOINT + 'admin/access-point-credit';
    // var msg_success = 'cadastrado';
    if(this.props.editing !== null){
      url += "/"+this.props.editing.id;
      // msg_success = 'alterado';
    }

    // Convertendo os setores em string
    var accesspoint_selects = [];
    for(var key in this.state.accesspoint) {
      if(key==='id'){
        accesspoint_selects = [this.state.accesspoint[key]];
      } else if(key!=='name'){
        accesspoint_selects[key] = this.state.accesspoint[key]['id'];
      }
    }
  
    // Enviando o formulário
    var form = new FormData();    
    form.append("user_id", accesspoint_selects);
    form.append("credit", this.state.credit);
    form.append("user_id_at", this.props.user.id);

    const response = await fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.props.user.access_token,
      }),
      body: form
    });
    const json = await response.json();
    if (json.return.code === 1) {
      this.setState({
        loading: true,
        error_message: 'Crédito adicionado com sucesso!',
        color_message: 'success'
      });
    }
    else if (json.return.code>300) {
      window.location = '/';
    }
    else {
      this.setState({
        loading: true,
        error_message: json.return.message
      });
    }
  }

  render() {
    var accesspoint_selects = [];
    for(var key in this.state.accesspoint) {
      if(key==='id'){
        accesspoint_selects = [this.state.accesspoint[key]];
      } else if(key!=='name'){
        accesspoint_selects[key] = this.state.accesspoint[key]['id'];
      }
    }    
    return (
      <Modal isOpen={this.props.visible} >
        <ModalHeader>Adicionar crédito lojista</ModalHeader>
          <ModalBody hidden={this.state.loading}>
            <Form>
              <SelectAPI
                label="lojista"
                name="accesspoint" 
                placeholder={"Selecione um lojista"}
                access_token={this.props.user.access_token}
                api="admin/access-point-select"
                selectedOption={this.handleInputChange}
                formInput={(accesspoint_selects==null?'':accesspoint_selects)}
                value={this.state.accesspoint}
                multi={false}
              />
              <Input
                label="Crédito"
                name="credit"
                onChange={this.handleInputChange}
                // mask={"000,00"}
                placeholder='R$ 0,00'
                invalid_message={Strings.required_field}
              />
            </Form>
          </ModalBody>
          <Loader
            body={ModalBody}
            hidden={!this.state.loading}
            message={this.state.error_message}
            color_message={this.state.color_message}
            onClose={() => this.setState({loading: false, error_message: '', color_message: ''})}
            onCloseSuccess={() => {this.toggle(true); this.setState({loading: false, error_message: '', color_message: ''});}}
          />
          <ModalFooter hidden={this.state.loading}>
            <Button outline color="secondary" onClick={this.register}>Salvar</Button>
            <Button outline color="danger" onClick={() => this.toggle(false)}>Cancelar</Button>
        </ModalFooter>
    </Modal>
    )
  }
}
export default AccessPointCreditCreate;


// WEBPACK FOOTER //
// ./src/components/AccessPointCreditCreate.js